module.exports = __webpack_public_path__ + "img/sponsor_RPC.1635a86d.png";